export const STATUS_DRAFT = 'draft';
export const STATUS_OPEN = 'open';
export const STATUS_PENDING_CONFIRMATION = 'pending_confirmation';
export const STATUS_PAID = 'paid';
export const STATUS_TOTAL = 'total';
export const STATUS_CANCELED = 'canceled';
export const STATUS_APPROVED = 'approved';
export const EMIT_INVOICE_FORM_OPEN = 'open-invoice-form';
export const EMIT_ITEMS_CHANGE = 'items-changed';
export const EMIT_INVOICE_CLICKED = 'invoice-clicked';
export const EMIT_INVOICES_CHANGE = 'invoices-changed';
export const EMIT_INVOICE_PAID = 'invoice-paid';
export const EMIT_PAYMENT_CLICKED = 'payment-clicked';
export const EMIT_PAYMENTS_CLICKED = 'payments-changed';
export const EMIT_SELECTED_INVOICES = 'selected-invoices';
export const EMIT_INVOICE_CHANGED = 'invoice-changed';

export let FORM_CHILD = null;

const BILLING_SETTINGS = {};

export function setFormChildGlobally(child) {
    FORM_CHILD = child
}

export const CARD_STATUS_STYLES = {
    draft: {title: 'text-gray-600', price: 'text-dark', count: 'text-gray-500', icon: 'fi-rr-document'},
    open: {title: 'text-gray-600', price: 'text-dark', count: 'text-secondary', icon: ' fi-rr-file-invoice'},
    paid: {title: 'text-gray-600', price: 'text-dark', count: 'text-success', icon: ' fi-rr-file-invoice-dollar'},
    total: {title: 'text-gray-600', price: 'text-dark', count: 'text-purple', icon: ' fi-rr-file-invoice-dollar'},

    confirmed: {title: 'text-gray-600', price: 'text-dark', count: 'text-success', icon: ' fi-rr-file-invoice-dollar'},
}

export const DEFAULT_STATUS_STYLES = {
    draft: {text: 'text-gray-600', bg: 'bg-light', border: 'border-default', icon: 'fi-rr-document'},
    open: {text: 'text-secondary', bg: 'bg-light-orange', border: 'border-secondary', icon: 'fi-rr-file-invoice'},
    paid: {
        text: 'text-dark-green',
        bg: 'bg-light-green',
        border: 'border-dark-green',
        icon: 'fi-rr-file-invoice-dollar'
    },
    canceled: {text: 'text-danger', bg: 'bg-light-red', border: 'border-danger', icon: 'fi-rr-cross-circle'},

    confirmed: {
        text: 'text-dark-green',
        bg: 'bg-light-green',
        border: 'border-dark-green',
        icon: 'fi-rr-file-invoice-dollar'
    },
}

export const BADGE_STYLES = {
    draft: {badge: 'badge-gray-500', badge_text: 'text-gray-600'},
    open: {badge: 'badge-secondary', badge_text: 'text-white'},
    canceled: {badge: 'badge-danger', badge_text: 'text-white'},
    paid: {badge: 'badge-success', badge_text: 'text-white'},

    confirmed: {badge: 'badge-success', badge_text: 'text-white'},
}

export const transStatus = (status) => trans(`general.page.space_billing.status.${status}`)


export const statusStyle = (status) => {
    return {...DEFAULT_STATUS_STYLES[status], ...BADGE_STYLES[status]};
}

export const getBillingSettings = async () => {
    if (Object.keys(BILLING_SETTINGS).length !== 0) return BILLING_SETTINGS;

    const response = await axios.get(`/settings/billing`);
    const mapType = {
        contract_sequence: 'sequences', invoice_sequence: 'sequences', payment_sequence: 'sequences',
    }
    response.data.data.data.forEach((setting) => {
        const type = mapType[setting.type] ?? setting.type
        BILLING_SETTINGS[type] ? BILLING_SETTINGS[type].push(setting) : BILLING_SETTINGS[type] = [setting]
    });

    return BILLING_SETTINGS;
}


export const getSpaceCurrency = async () => {
    const settings = await getBillingSettings()

    return settings.space_currency ? {
        name: settings.space_currency[0].description,
        code: settings.space_currency[0].value,
        symbol: settings.space_currency[0].label,
        ...settings.space_currency[0]
    } : null
}
